import api from "@/lib/Api";

export const fetchEmployeeDiscountTemplate = async (month) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountTemplate/${month}`;
    const fetchRes = api.axios.get(queryRoute, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const fetchEmployeeDiscountTemplateFromPast = async (month) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountTemplateFromPast/${month}`;
    const fetchRes = api.axios.get(queryRoute, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createEmployeeDiscount = async (data) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscount`;
    const reqBody = { data };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const fetchEmployeeDiscount = async (start, end) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscount?reqBody=${JSON.stringify(
      {
        start,
        end,
      }
    )}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getEmployeeDiscountInvoice = async (start, end) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountInvoice?reqBody=${JSON.stringify(
      {
        start,
        end,
      }
    )}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getEmployeeDiscountPreSignedUrl = async (imageArr) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountPreSignedUrl?reqBody=${JSON.stringify(
      {
        imageArr: imageArr,
      }
    )}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateEmployeeDiscountInvoiceApprove = async (
  approved,
  invoiceId
) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountInvoiceApprove`;
    const reqBody = { approved, invoiceId };
    const fetchRes = api.axios.put(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateEmployeeDiscountInvoiceVerified = async (
  verified,
  invoiceId
) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountInvoiceVerified`;
    const reqBody = { verified, invoiceId };
    const fetchRes = api.axios.put(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const fetchEmployeeDiscountReport = async (
  start,
  end,
  typeId,
  selectedDate
) => {
  try {
    let execQueryRoute = "";

    const queryRouteByProduct = `/employeePurchase/employeeDiscountReportByProduct?reqBody=${JSON.stringify(
      {
        start,
        end,
      }
    )}`;

    const queryRouteByUser = `/employeePurchase/employeeDiscountReportByUser?reqBody=${JSON.stringify(
      {
        start,
        end,
        selectedDate,
      }
    )}`;

    switch (typeId) {
      case 1:
        execQueryRoute = queryRouteByProduct;
        break;
      case 2:
        execQueryRoute = queryRouteByUser;
        break;
    }

    const fetchRes = api.axios.get(execQueryRoute, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createEmployeeDiscountMonthly = async (data) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountMonthly`;
    const reqBody = { data };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getEmployeeDiscountMonthly = async (start, end) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountMonthly?reqBody=${JSON.stringify(
      {
        start,
        end,
      }
    )}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getEmployeeDiscountMonthlyAvailable = async (month) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountMonthlyAvailable/${month}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getEmployeeDiscountMonthlyListAvailable = async (month) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountPastMonthlyListAvailable/${month}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getAllEmployeeDiscountProducts = async () => {
  try {
    const queryRoute = `/employeePurchase/getAllEmployeeDiscountProducts`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createEmployeeDiscountByOne = async (data) => {
  try {
    const queryRoute = `/employeePurchase/employeeDiscountByOne`;
    const reqBody = { data };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
